import React from "react";

function Footer() {
    return <footer>IEEE AAST Alex SB - Recruitment form demo</footer>;
}

export default Footer;
